import { PUBLIC_DIFFUSION_API_ENDPOINT } from '$env/static/public';
import {
	Client as DiffusionApiClient,
	type GeneratedPointCloud,
	type GeneratedPointCloudPatch
} from '$lib/diffusionApi';

export default class PointCloudClient {
	private diffusionApiClient: DiffusionApiClient;

	constructor(token: string) {
		this.diffusionApiClient = new DiffusionApiClient({
			BASE: PUBLIC_DIFFUSION_API_ENDPOINT,
			TOKEN: token
		});
	}

	public setToken(token: string) {
		this.diffusionApiClient = new DiffusionApiClient({
			BASE: PUBLIC_DIFFUSION_API_ENDPOINT,
			TOKEN: token
		});
	}

	public async getGeneratedPointClouds(
		userId: string,
		saved: boolean,
		config?: {
			skip?: number;
			limit?: number;
			most_recent_first?: boolean;
			generation_ids?: string[];
			journey_id?: string;
		}
	): Promise<GeneratedPointCloud[]> {
		const response =
			await this.diffusionApiClient.default.getGeneratedPointCloudsGeneratedPointCloudsGet(
				userId,
				saved,
				config?.skip,
				config?.limit,
				config?.most_recent_first,
				config?.generation_ids,
				config?.journey_id
			);
		return response.point_clouds;
	}

	public async getGeneratedPointCloud(generationId: string) {
		try {
			const response =
				await this.diffusionApiClient.default.getGeneratedPointCloudGeneratedPointCloudGet(
					generationId
				);
			return response;
		} catch (error) {
			console.error(error);
			return undefined;
		}
	}

	public async patchGeneratedPointClouds(patches: GeneratedPointCloudPatch[]) {
		try {
			const response =
				await this.diffusionApiClient.default.patchGeneratedPointCloudsGeneratedPointCloudsPatch({
					patches
				});
			return response;
		} catch (error) {
			console.error(error);
			return undefined;
		}
	}

	public async getVox(generationId: string, gridSize: number) {
		try {
			const response = await this.diffusionApiClient.default.getVoxFileVoxFileGet(
				generationId,
				gridSize,
				''
			);
			return response;
		} catch (error) {
			console.error(error);
			return undefined;
		}
	}

	public async getGlb(generationId: string, gridSize: number) {
		try {
			const response = await this.diffusionApiClient.default.getGlbFileGlbFileGet(
				generationId,
				gridSize
			);
			return response;
		} catch (error) {
			console.error(error);
			return undefined;
		}
	}
}
